import {html, css, TemplateResult, CSSResultGroup} from 'lit'
import {customElement, property} from 'lit/decorators.js'
import {BaseComponent} from '../base-component.js'

@customElement('il-card-section-item')
export default class CardSectionItemComponent extends BaseComponent {
  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      .il-card-section-item {
        display: flex;
        gap: 8px;
        justify-content: space-between;
        align-items: center;
        position: relative;
        color: var(--il-color-neutrals-300);
        font-size: var(--il-font-size-14);
        font-weight: var(--il-font-weight-normal);
        line-height: var(--il-font-line-height-140);
        letter-spacing: var(--il-font-letter-spacing-2);
      }

      .il-card-section-item .il-card-section-item__main {
        display: flex;
        gap: 8px;
      }

      .il-card-section-item .il-card-section-item__left {
        min-width: 20px;
        text-align: center;
      }

      .il-card-section-item .il-card-section-item__right {
        font-weight: var(--il-font-weight-bold);
      }

      .il-card-section-item .il-card-section-item__extra {
        font-size: var(--il-font-size-12);
        font-weight: var(--il-font-weight-normal);
        line-height: var(--il-font-line-height-150);
        letter-spacing: var(--il-font-letter-spacing-1);
      }
    `,
  ]

  @property({attribute: 'left-text', type: String})
  leftText: string = ''

  @property({attribute: 'right-text', type: String})
  rightText: string = ''

  @property({attribute: 'extra-text', type: String})
  extraText: string = ''

  @property({type: String})
  text: string = ''

  rightTextComponent (): TemplateResult {
    if (this.rightText) {
      return html` <div
        class="il-card-section-item__right"
        data-test-iliad-card-section-item-right
      >
        ${this.rightText}
      </div>`
    }

    return html``
  }

  leftTextComponent (): TemplateResult {
    if (this.leftText) {
      return html` <div
        class="il-card-section-item__left"
        data-test-iliad-card-section-item-left
      >
        ${this.leftText}
      </div>`
    }

    return html``
  }

  extraTextComponent (): TemplateResult {
    if (this.extraText) {
      return html` <div
        class="il-card-section-item__extra"
        data-test-iliad-card-section-item-extra
      >
        - ${this.extraText}
      </div>`
    }

    return html``
  }

  override render (): TemplateResult {
    return html`
      <div
        class="${this.baseCSSClass} il-card-section-item"
        data-test-iliad-section-item
      >
        <div
          class="il-card-section-item__main"
          data-test-iliad-section-item-main
        >
          ${this.leftTextComponent()} ${this.text} ${this.extraTextComponent()}
        </div>

        ${this.rightTextComponent()}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'il-card-section-item': CardSectionItemComponent
  }
}
